import React, {Suspense, useState, useRef, useEffect } from "react";
// import { PDFViewer } from "../AffichagePDF/PDFViewer";
import pignon from './pignon.gif';

function Cv() {
  const [showDiv, setShowDiv] = useState(true);
  const [displayedDiv, setDisplayedDiv] = useState(true);
  const divRef = useRef(null);
  const [lienPdf, setLienPdf] = useState("./Cv/cv.pdf");
  const PDFViewer = React.lazy(() => import("../AffichagePDF/PDFViewer"));
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target.closest(".modal-content") &&
        !event.target.closest(".svg_cv") &&
        displayedDiv
      ) {
        setDisplayedDiv(false);
        // console.log("couper")
      }
    }
    if (displayedDiv && !showDiv) {
      document.addEventListener("click", handleClickOutside);
    }

    if (showDiv) {
      setDisplayedDiv(true);

      setShowDiv(false);
    }

    // console.log(`showDiv ${showDiv} - displayedDiv ${displayedDiv}`)
  }, [showDiv, displayedDiv]);

  function handleButtonClick(link) {
    if (!displayedDiv) {
      setShowDiv(true);
      setLienPdf(link);
    }
  }
  const suspence = <div
style={{
  backgroundImage: `url(${pignon})`,
  backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '15%',
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
}}
>

</div>

  return (
    <>
      <main className="projects-overview">
        <section className="section_cv">
          {/* <h3>Si vous avez des dificultées d'afficher toutes les pages</h3> */}
          <ul className="ul_cv">
            <li className="cv">
              <div
                className="svg_cv"
                onClick={() => handleButtonClick("./Cv/cv1.pdf")}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="-100 0 1024 1024"
                  fill="none"
                  transform="scale(1)"
                >
                  <path
                    fill="#8d8d8d"
                    d="m279.9 388.4c-0.7 0-1.5 0-2.2-0.1-0.7 0-1.5-0.1-2.2-0.2s-1.5-0.2-2.2-0.3-1.5-0.2-2.2-0.4c-0.7-0.1-1.4-0.3-2.2-0.5l-2.1-0.6c-0.7-0.2-1.4-0.4-2.1-0.7-0.7-0.2-1.4-0.5-2.1-0.8s-1.3-0.6-2-0.9-1.3-0.6-2-1c-0.6-0.3-1.3-0.7-1.9-1.1s-1.3-0.8-1.9-1.2-1.2-0.8-1.8-1.3c-0.6-0.4-1.2-0.9-1.8-1.4s-1.1-0.9-1.7-1.4c-0.5-0.5-1.1-1-1.6-1.5s-1-1.1-1.5-1.6-1-1.1-1.4-1.7c-0.5-0.6-0.9-1.2-1.4-1.7-0.4-0.6-0.9-1.2-1.3-1.8s-0.8-1.2-1.2-1.9c-0.4-0.6-0.7-1.3-1.1-1.9-0.3-0.6-0.7-1.3-1-2s-0.6-1.3-0.9-2-0.5-1.4-0.8-2c-0.2-0.7-0.5-1.4-0.7-2.1l-0.6-2.1c-0.2-0.7-0.3-1.4-0.5-2.2-0.1-0.7-0.3-1.4-0.4-2.2-0.1-0.7-0.2-1.5-0.3-2.2s-0.1-1.5-0.2-2.2c0-0.7-0.1-1.5-0.1-2.2s0-1.5 0.1-2.2c0-0.7 0.1-1.5 0.2-2.2s0.2-1.5 0.3-2.2 0.2-1.4 0.4-2.2c0.2-0.7 0.3-1.4 0.5-2.1l0.6-2.1c0.2-0.7 0.5-1.4 0.7-2.1s0.5-1.4 0.8-2.1 0.6-1.4 0.9-2c0.3-0.7 0.7-1.3 1-2 0.3-0.6 0.7-1.3 1.1-1.9s0.8-1.3 1.2-1.9 0.8-1.2 1.3-1.8c0.4-0.6 0.9-1.2 1.4-1.7 0.5-0.6 1-1.1 1.4-1.7 0.5-0.5 1-1.1 1.5-1.6s1.1-1 1.6-1.5 1.1-1 1.7-1.4c0.6-0.5 1.2-0.9 1.8-1.4 0.6-0.4 1.2-0.9 1.8-1.3s1.2-0.8 1.9-1.2c0.6-0.4 1.3-0.7 1.9-1.1 0.6-0.3 1.3-0.7 2-1s1.3-0.6 2-0.9 1.4-0.5 2.1-0.8c0.7-0.2 1.4-0.5 2.1-0.7l2.1-0.6c0.7-0.2 1.4-0.3 2.2-0.5 0.7-0.1 1.5-0.3 2.2-0.4s1.5-0.2 2.2-0.3 1.5-0.1 2.2-0.2c1.5-0.1 3-0.1 4.4 0 0.7 0 1.5 0.1 2.2 0.2s1.5 0.2 2.2 0.3 1.5 0.2 2.2 0.4c0.7 0.1 1.4 0.3 2.2 0.5l2.1 0.6c0.7 0.2 1.4 0.5 2.1 0.7s1.4 0.5 2 0.8c0.7 0.3 1.4 0.6 2 0.9 0.7 0.3 1.3 0.6 2 1 0.6 0.3 1.3 0.7 1.9 1.1s1.2 0.8 1.9 1.2c0.6 0.4 1.2 0.8 1.8 1.3 0.6 0.4 1.2 0.9 1.8 1.4s1.1 1 1.7 1.4c0.5 0.5 1.1 1 1.6 1.5s1 1.1 1.5 1.6 1 1.1 1.5 1.7 0.9 1.1 1.4 1.7c0.4 0.6 0.9 1.2 1.3 1.8s0.8 1.2 1.2 1.9c0.4 0.6 0.7 1.3 1.1 1.9 0.3 0.6 0.7 1.3 1 2s0.6 1.3 0.9 2 0.5 1.4 0.8 2.1c0.2 0.7 0.5 1.4 0.7 2.1l0.6 2.1c0.2 0.7 0.3 1.4 0.5 2.1 0.1 0.7 0.3 1.5 0.4 2.2s0.2 1.5 0.3 2.2 0.1 1.5 0.2 2.2c0 0.7 0.1 1.5 0.1 2.2s0 1.5-0.1 2.2c0 0.7-0.1 1.5-0.2 2.2s-0.2 1.5-0.3 2.2-0.2 1.5-0.4 2.2c-0.1 0.7-0.3 1.4-0.5 2.2l-0.6 2.1c-0.2 0.7-0.4 1.4-0.7 2.1-0.2 0.7-0.5 1.4-0.8 2-0.3 0.7-0.6 1.4-0.9 2-0.3 0.7-0.6 1.3-1 2-0.3 0.7-0.7 1.3-1.1 1.9s-0.8 1.3-1.2 1.9-0.8 1.2-1.3 1.8c-0.4 0.6-0.9 1.2-1.4 1.7-0.5 0.6-1 1.1-1.5 1.7s-1 1.1-1.5 1.6-1.1 1-1.6 1.5-1.1 1-1.7 1.4c-0.6 0.5-1.2 0.9-1.8 1.4-0.6 0.4-1.2 0.9-1.8 1.3s-1.2 0.8-1.9 1.2c-0.6 0.4-1.3 0.7-1.9 1.1-0.7 0.3-1.3 0.7-2 1s-1.3 0.6-2 0.9-1.4 0.5-2 0.8c-0.7 0.2-1.4 0.5-2.1 0.7l-2.1 0.6c-0.7 0.2-1.4 0.3-2.2 0.5-0.7 0.1-1.5 0.3-2.2 0.4s-1.5 0.2-2.2 0.3-1.5 0.1-2.2 0.2-1.5 0.1-2.2 0.1zm-48.3 187.6h329.3v40h-329.3z"
                  />
                  <circle cx="280.1" cy="343.6" r="45.2" />
                  <path
                    fill="#8d8d8d"
                    d="m231.6 677.6h329.3v40h-329.3zm0-203.3h329.3v40h-329.3z"
                  />
                  <path
                    fill="#8d8d8d"
                    d="m400 0c-276.1 0-500 223.9-500 500s223.9 500 500 500 500-223.9 500-500-223.9-500-500-500zm230.8 794.5c0 11-9 20-20 20h-420.5c-11 0-20-9-20-20v-587.3c0-11 9-20 20-20l239.2 0.2v166.3c0 16.8 13.8 30.6 30.6 30.6h171.3zm0.6-456.5h-155.6v-150.5l155.5 150.1v0.4z"
                  />
                </svg>
                &nbsp; Page 1
              </div>
            </li>
            <li className="cv">
              <div
                className="svg_cv"
                onClick={() => handleButtonClick("./Cv/cv2.pdf")}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="-100 0 1024 1024"
                  fill="none"
                  transform="scale(1)"
                >
                  <path
                    fill="#8d8d8d"
                    d="m279.9 388.4c-0.7 0-1.5 0-2.2-0.1-0.7 0-1.5-0.1-2.2-0.2s-1.5-0.2-2.2-0.3-1.5-0.2-2.2-0.4c-0.7-0.1-1.4-0.3-2.2-0.5l-2.1-0.6c-0.7-0.2-1.4-0.4-2.1-0.7-0.7-0.2-1.4-0.5-2.1-0.8s-1.3-0.6-2-0.9-1.3-0.6-2-1c-0.6-0.3-1.3-0.7-1.9-1.1s-1.3-0.8-1.9-1.2-1.2-0.8-1.8-1.3c-0.6-0.4-1.2-0.9-1.8-1.4s-1.1-0.9-1.7-1.4c-0.5-0.5-1.1-1-1.6-1.5s-1-1.1-1.5-1.6-1-1.1-1.4-1.7c-0.5-0.6-0.9-1.2-1.4-1.7-0.4-0.6-0.9-1.2-1.3-1.8s-0.8-1.2-1.2-1.9c-0.4-0.6-0.7-1.3-1.1-1.9-0.3-0.6-0.7-1.3-1-2s-0.6-1.3-0.9-2-0.5-1.4-0.8-2c-0.2-0.7-0.5-1.4-0.7-2.1l-0.6-2.1c-0.2-0.7-0.3-1.4-0.5-2.2-0.1-0.7-0.3-1.4-0.4-2.2-0.1-0.7-0.2-1.5-0.3-2.2s-0.1-1.5-0.2-2.2c0-0.7-0.1-1.5-0.1-2.2s0-1.5 0.1-2.2c0-0.7 0.1-1.5 0.2-2.2s0.2-1.5 0.3-2.2 0.2-1.4 0.4-2.2c0.2-0.7 0.3-1.4 0.5-2.1l0.6-2.1c0.2-0.7 0.5-1.4 0.7-2.1s0.5-1.4 0.8-2.1 0.6-1.4 0.9-2c0.3-0.7 0.7-1.3 1-2 0.3-0.6 0.7-1.3 1.1-1.9s0.8-1.3 1.2-1.9 0.8-1.2 1.3-1.8c0.4-0.6 0.9-1.2 1.4-1.7 0.5-0.6 1-1.1 1.4-1.7 0.5-0.5 1-1.1 1.5-1.6s1.1-1 1.6-1.5 1.1-1 1.7-1.4c0.6-0.5 1.2-0.9 1.8-1.4 0.6-0.4 1.2-0.9 1.8-1.3s1.2-0.8 1.9-1.2c0.6-0.4 1.3-0.7 1.9-1.1 0.6-0.3 1.3-0.7 2-1s1.3-0.6 2-0.9 1.4-0.5 2.1-0.8c0.7-0.2 1.4-0.5 2.1-0.7l2.1-0.6c0.7-0.2 1.4-0.3 2.2-0.5 0.7-0.1 1.5-0.3 2.2-0.4s1.5-0.2 2.2-0.3 1.5-0.1 2.2-0.2c1.5-0.1 3-0.1 4.4 0 0.7 0 1.5 0.1 2.2 0.2s1.5 0.2 2.2 0.3 1.5 0.2 2.2 0.4c0.7 0.1 1.4 0.3 2.2 0.5l2.1 0.6c0.7 0.2 1.4 0.5 2.1 0.7s1.4 0.5 2 0.8c0.7 0.3 1.4 0.6 2 0.9 0.7 0.3 1.3 0.6 2 1 0.6 0.3 1.3 0.7 1.9 1.1s1.2 0.8 1.9 1.2c0.6 0.4 1.2 0.8 1.8 1.3 0.6 0.4 1.2 0.9 1.8 1.4s1.1 1 1.7 1.4c0.5 0.5 1.1 1 1.6 1.5s1 1.1 1.5 1.6 1 1.1 1.5 1.7 0.9 1.1 1.4 1.7c0.4 0.6 0.9 1.2 1.3 1.8s0.8 1.2 1.2 1.9c0.4 0.6 0.7 1.3 1.1 1.9 0.3 0.6 0.7 1.3 1 2s0.6 1.3 0.9 2 0.5 1.4 0.8 2.1c0.2 0.7 0.5 1.4 0.7 2.1l0.6 2.1c0.2 0.7 0.3 1.4 0.5 2.1 0.1 0.7 0.3 1.5 0.4 2.2s0.2 1.5 0.3 2.2 0.1 1.5 0.2 2.2c0 0.7 0.1 1.5 0.1 2.2s0 1.5-0.1 2.2c0 0.7-0.1 1.5-0.2 2.2s-0.2 1.5-0.3 2.2-0.2 1.5-0.4 2.2c-0.1 0.7-0.3 1.4-0.5 2.2l-0.6 2.1c-0.2 0.7-0.4 1.4-0.7 2.1-0.2 0.7-0.5 1.4-0.8 2-0.3 0.7-0.6 1.4-0.9 2-0.3 0.7-0.6 1.3-1 2-0.3 0.7-0.7 1.3-1.1 1.9s-0.8 1.3-1.2 1.9-0.8 1.2-1.3 1.8c-0.4 0.6-0.9 1.2-1.4 1.7-0.5 0.6-1 1.1-1.5 1.7s-1 1.1-1.5 1.6-1.1 1-1.6 1.5-1.1 1-1.7 1.4c-0.6 0.5-1.2 0.9-1.8 1.4-0.6 0.4-1.2 0.9-1.8 1.3s-1.2 0.8-1.9 1.2c-0.6 0.4-1.3 0.7-1.9 1.1-0.7 0.3-1.3 0.7-2 1s-1.3 0.6-2 0.9-1.4 0.5-2 0.8c-0.7 0.2-1.4 0.5-2.1 0.7l-2.1 0.6c-0.7 0.2-1.4 0.3-2.2 0.5-0.7 0.1-1.5 0.3-2.2 0.4s-1.5 0.2-2.2 0.3-1.5 0.1-2.2 0.2-1.5 0.1-2.2 0.1zm-48.3 187.6h329.3v40h-329.3z"
                  />
                  <circle cx="280.1" cy="343.6" r="45.2" />
                  <path
                    fill="#8d8d8d"
                    d="m231.6 677.6h329.3v40h-329.3zm0-203.3h329.3v40h-329.3z"
                  />
                  <path
                    fill="#8d8d8d"
                    d="m400 0c-276.1 0-500 223.9-500 500s223.9 500 500 500 500-223.9 500-500-223.9-500-500-500zm230.8 794.5c0 11-9 20-20 20h-420.5c-11 0-20-9-20-20v-587.3c0-11 9-20 20-20l239.2 0.2v166.3c0 16.8 13.8 30.6 30.6 30.6h171.3zm0.6-456.5h-155.6v-150.5l155.5 150.1v0.4z"
                  />
                </svg>
                &nbsp; Page 2
              </div>
            </li>
          </ul>
          {displayedDiv && (
            <div className="modal" ref={divRef}>
              <div className="modal-content">
              <Suspense fallback={suspence} >
                <PDFViewer link={lienPdf} />
            </Suspense  >
              </div>
            </div>
          )}
        </section>
      </main>
    </>
  );
}

export default Cv;
